import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import '../App.css';
import html2canvas from 'html2canvas';
import logo from '../campofruver-blanco-y-negro-1.png'

const Tarjeta = ({ nombreTitular, numeroTarjeta, cvv, contactoTitular }) => {
    const qrRef = useRef(null);
    const cardRef = useRef(null);

   
    useEffect(() => {
        const qrData = `/search?${encodeURIComponent(numeroTarjeta*3)}nombre=${encodeURIComponent(nombreTitular)}&numero=${encodeURIComponent(numeroTarjeta)}&cvv=${encodeURIComponent(cvv)}&contacto=${encodeURIComponent(contactoTitular)}`;
        QRCode.toCanvas(qrRef.current, qrData, { width: 100 }, (error) => {
            if (error) console.error('Error generating QR code:', error);
        });
    }, [nombreTitular, numeroTarjeta, cvv, contactoTitular]);

    const handleDownload = () => {
        const card = cardRef.current;

        html2canvas(card).then((canvas) => {
            const link = document.createElement('a');
            link.download = `Tajeta ${nombreTitular}.jpg`;
            link.href = canvas.toDataURL('image/jpeg');
            link.click();
        }).catch((error) => {
            console.error('Error generando imagen:', error);
        });
    };
    const capitalizarNombre = (nombreCompleto) => {
  if (!nombreCompleto) return '';

  return nombreCompleto
    .toLowerCase()
    .split(' ')
    .filter(palabra => palabra.length > 0)
    .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
    .join(' ');
};

const url =  `/search?${encodeURIComponent(numeroTarjeta*cvv)}&ref=${encodeURIComponent(numeroTarjeta*cvv)}&tarjeta-campo-fruver-cliente-fiel=${encodeURIComponent(numeroTarjeta*cvv)}${encodeURIComponent(numeroTarjeta*3)}nombre=${encodeURIComponent(nombreTitular)}&numero=${encodeURIComponent(numeroTarjeta)}&codigo=${encodeURIComponent(numeroTarjeta*9)}&cvv=${encodeURIComponent(cvv)}&contacto=${encodeURIComponent(contactoTitular)}`;
    return (
        <div>
            
            <div className="credit-card" ref={cardRef}>
                <div className="credit-card__content">
                    <div className="credit-card__number">
                        {numeroTarjeta.replace(/(.{4})/g, '$1 ')}
                    </div>
                    <div className="credit-card__info">
                   <img  className="credit-card-logoppal" src={logo} alt="" />
                  <div className="credit-card__name">
  {capitalizarNombre(nombreTitular)}
</div>

                  </div>
                </div>
            </div>
    <div className="credit-card" ref={cardRef}>
                <div className="credit-card__content">
                  
                    <div className="credit-card__info">
                    <canvas ref={qrRef} className="credit-card__qr"></canvas>
                   <img  className="credit-card__logo" src={logo} alt="" />
                       
                        <div className="credit-card__cvv">CVV: {cvv}</div>
                        <div className='info-card'>Obtén descuentos y promociones exclusivas con tu tarjeta cliente Campo Fruver. Es unicamente de uso personal</div>
                 </div>
                </div>
            </div>
            <button className='btn btn-success' onClick={handleDownload}>Descargar Tarjeta</button>
            <a className={'btn btn-primary'}href={`https://web.whatsapp.com/send/?phone=57${contactoTitular}&text=hola+esta+es+tu+tarjeta+cliente+fiel` }  target="_blank">abrir wpp</a>
         <a href={url}>abrir</a>
        </div>
    );
};

export default Tarjeta;
